import { useQuery, UseQueryOptions, UseQueryResult, useQueryClient } from "@tanstack/react-query"
import ResponseError from "../../../types/responseError"
import { Benefit } from "#/lib/carrot-api/types/Benefit"
import { carrotClient } from "#/utils/CarrotClient"

const ENDPOINT = "GetBenefit"

export const getBenefitCacheKey = (): (string | number)[] => [ENDPOINT]

export default function useBenefit<TData = Benefit>(
  options?: Pick<UseQueryOptions<Benefit, ResponseError, TData>, "select">
): UseQueryResult<TData, ResponseError> {
  return useQuery<Benefit, ResponseError, TData>(getBenefitCacheKey(), () => carrotClient.getBenefit(), options)
}

export function useCreateOverride(): (attributes: Benefit) => void {
  const queryClient = useQueryClient()
  return (attributes: Benefit) => {
    queryClient.setQueryDefaults(getBenefitCacheKey(), { staleTime: Infinity, cacheTime: Infinity })
    queryClient.setQueryData(getBenefitCacheKey(), attributes)
  }
}
